import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { TextValidationField } from "./TextField";
import { PasswordShowHideButton } from "../login/PasswordShowHideButton";

export const NewFADVPasswordField = ({ passwordValidator, match, oldPwd, onSubmit, id, name, disabled, label, fullWidth, inputRef, onBlur, ...remainingProps }) => {
  const [ showPassword, setShowPassword ] = useState(false);
  const innerRef = useRef(null);

  useEffect(() => {
    // This effect allows external refs, but also allows the hide/show button to work correctly.
    if (inputRef) {
      if (typeof inputRef === "function") {
        inputRef(innerRef.current);
      } else if (typeof inputRef === "object") {
        inputRef.current = innerRef.current;
      }
    }
  }, [inputRef]);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    if (innerRef.current) {
      innerRef.current.focus();
    }
  };
  const handleBlur = () => {
    if (typeof onBlur === "function") {
      onBlur();
    };
    setShowPassword(false);
  };

  const bespokeWrapperClassName = "";
  return (
    <div className={bespokeWrapperClassName}>
      <TextValidationField
        {...remainingProps}
        id={id}
        name={name}
        disabled={disabled}
        textType={showPassword ? "text" : "password"}
        validator={passwordValidator}
        match={match}
        oldText={oldPwd}
        onBlur={handleBlur}
        onSubmit={onSubmit}
        label={label}
        fullWidth={fullWidth}
        inputRef={innerRef}
        adornment={<PasswordShowHideButton showPassword={showPassword} onClick={handleTogglePasswordVisibility} />}
      />
    </div>
  )
}

NewFADVPasswordField.propTypes = {
  passwordValidator: PropTypes.shape({ 
    validateTextRules: PropTypes.func.isRequired,
    validateTextFormat: PropTypes.func.isRequired,
  }),
  match: PropTypes.string,
  oldPwd: PropTypes.string,
  onSubmit: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.object })]),
  label: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.string,
  ]),
  value: PropTypes.string,
  fullWidth: PropTypes.bool,
}